import { render, staticRenderFns } from "./BaseHome.vue?vue&type=template&id=572129a6&"
import script from "./BaseHome.vue?vue&type=script&lang=js&"
export * from "./BaseHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports